// Report client. Mirrors middleware/routes/reports.py.
//
// POST /reports/generate accepts the drawer's queue + the chart PNGs the
// client captured at "Add" time, runs the items through Claude to author
// title + executive summary + per-item insight, then renders a PDF via
// WeasyPrint and streams it back. The browser downloads the blob.

import { api } from "../../api/base";
import type { ReportItem } from "./ReportContext";

interface GenerateArgs {
  organization: string;
  thread_id: number | null;
  items: ReportItem[];
}

interface WireItem {
  id: string;
  kind: "chart" | "answer";
  title: string;
  user_query: string;
  // chart-only
  image_png?: string;
  datasource_id?: string;
  rows?: ReadonlyArray<ReadonlyArray<string | number | boolean | null>>;
  columns?: ReadonlyArray<string>;
  // answer-only
  text?: string;
  insights?: string[];
}

function toWire(item: ReportItem): WireItem {
  if (item.kind === "chart") {
    return {
      id: item.id,
      kind: "chart",
      title: item.title,
      user_query: item.userQuery,
      image_png: item.imagePng,
      datasource_id: item.datasourceId,
      rows: item.rows,
      columns: item.columns,
    };
  }
  return {
    id: item.id,
    kind: "answer",
    title: item.title,
    user_query: item.userQuery,
    text: item.text,
    insights: item.insights,
  };
}

export async function generateReport(bearer: string, args: GenerateArgs): Promise<Blob> {
  const resp = await fetch(api("/reports/generate"), {
    method: "POST",
    headers: {
      Authorization: `Bearer ${bearer}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      organization: args.organization,
      thread_id: args.thread_id,
      items: args.items.map(toWire),
    }),
  });
  if (!resp.ok) {
    const text = await resp.text().catch(() => "");
    throw new Error(`/reports/generate returned ${resp.status}: ${text}`);
  }
  return await resp.blob();
}
